import { Component, Input, OnInit } from '@angular/core';
import { CdkDragDrop, transferArrayItem } from '@angular/cdk/drag-drop';
import { Offer, Slot } from '../../../reservation.model';
import { CancellationStatuses, Status } from '../../../../common/enums/Status';
import { ReservationService } from '../../../reservation.service';

@Component({
	selector: 'app-reservation-summary-offer',
	templateUrl: './reservation-summary-offer.component.html',
	styleUrls: ['./reservation-summary-offer.component.scss'],
})
export class ReservationSummaryOfferComponent implements OnInit {
	@Input() offer: Offer = null;
	@Input() index: number = null;
	initialSlots: Slot[] = [];
	protected readonly Status = Status;

	constructor(public service: ReservationService) {}

	ngOnInit(): void {
		if (this.offer) {
			this.initialSlots = [...this.offer.slot];
		}
	}

	drop(event: CdkDragDrop<Slot[]>, offer: Offer) {
		transferArrayItem(event.previousContainer.data, event.container.data, event.previousIndex, event.currentIndex);
	}

	protected isParticipantDisabled(slot: Slot) {
		return CancellationStatuses.includes(slot.status as Status);
	}
}
